<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Carga de planillas</h1>
    </div>

    <wz-table-container>
      <wz-table-toolbar>
        <template #left>
          <wz-filter-menu
            :options="filterOptions"
            :selected-option-filter="filters"
            @setFilters="setFilters"
          />
        </template>
        <template #right>
          <wz-tooltip text="Recargar">
            <wz-button variant="outline" @click="loadData">
              <i class="ri-loop-right-line"></i>
            </wz-button>
          </wz-tooltip>
          <wz-search-bar
            placeholder="Buscar por nombre del archivo y cargado por"
            @search="onSearch"
            @input="search = $event"
          />
          <wz-button variant="primary" @click="$router.push({ name: 'payroll-base-batch-upload' })">Cargar</wz-button>
        </template>
        <template #filters v-if="showFiltersList">
          <wz-badge
            v-for="(val, name) in filterList"
            :key="name"
            variant="primary"
            pill
            dismissible
            @dismiss="deleteFilter(name)"
          >
            {{ getFilterName(name, val) }}
          </wz-badge>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Fecha de carga</th>
            <th>Nombre del archivo</th>
            <th>Periodo</th>
            <th>Cargado por</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="list.length === 0">
            <td colspan="5" class="text-center text-muted py-4">No se encontraron resultados.</td>
          </tr>
          <tr v-for="o in list" :key="o.id">
            <td v-local-date:hour="o.uploadDate"></td>
            <td>{{ o.file ? o.file.name : '-' }}</td>
            <td>{{ o.period }}</td>
            <td>{{ trimEmail(o.createdBy) }}</td>
            <td style="text-align: center">
              <wz-dropdown
                :items="[{ key: 'download', label: 'Descargar' }]"
                placement="left"
                @click="handleAction(o, $event)"
              />
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <span>{{ total || list.length }} registro(s)</span>
      </wz-table-footer>
    </wz-table-container>
  </div>
</template>

<script>
import { PayrollBatchService } from "@/core/services";
import { Alert } from "@wizepe/wizeui"
import { Util } from "@wizepe/wizeui"
import { Constants as LocalConstants } from "@/core/utils";
import { FilterMixin } from "@wizepe/wizeui"
import { PaginationMixin } from "@wizepe/wizeui"

export default {
  mixins: [FilterMixin, PaginationMixin],
  data() {
    return {
      list: [],
      filterOptions: [
        {
          label: "Periodo",
          key: "period",
          type: LocalConstants.TypeFilters.SINGLE,
          options: [
            { key: 1, label: 'Periodo 1' },
            { key: 2, label: 'Periodo 2' },
          ],
        },
      ],
    };
  },
  methods: {
    handleAction(o, item) {
      if (item.key === 'download') this.download(o.file)
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = { page: this.page - 1, size: this.pageSize, sort: "id" };
        const data = { search: this.search, ...this.filters };
        const response = await PayrollBatchService.list(data, params);
        this.list = response.payload.content || [];
        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : 'Error al cargar las planillas');
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    download(asset) {
      if (asset) Util.downloadFile(asset.url, asset.name);
    },
    trimEmail(val) {
      return Util.trimEmail(val);
    },
  },
  async mounted() {
    await this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus" scoped></style>
